
import * as d3 from 'd3'
export default {
  methods: {

    draw_Search() {

      let data__ = {
        x         : this.search.x,
        y         : this.search.y,
        width     : 200,
        height    : 65.5,
        label     : 'Search',
        labelWidth: 40,
        targets: [{text: this.search.note},],
        callFunc: this.call_Search,
      }
      this.gmx_SearchTool(this.canvasOptions, data__) //---> Global function
      d3.select('#search_input').text(this.search.input)
    }, 

    
    call_Search(input=null, from) {
      
      this.search.input = input

      this.filteringData()
      this.canvasSystems.remove()
      this.draw_SystemList()
    },


    

  }
}